export const TECH_SUPPORT_ROLE = 'TECH_SUPPORT';

export const ADMIN_LIKE_ROLES = ['ADMIN', TECH_SUPPORT_ROLE] as const;

// Everyone except SERVER (the file package API rejects it). ADMIN also admits TECH_SUPPORT.
export const DOWNLOADS_ROLES = ['ADMIN', 'OPERATOR', 'ACCOUNTANT', 'BILLING'];

export const isTechSupportRole = (roleId?: string | null) => roleId === TECH_SUPPORT_ROLE;

export const isAdminLikeRole = (roleId?: string | null) =>
  roleId === 'ADMIN' || roleId === TECH_SUPPORT_ROLE;

export const hasRoleAccess = (userRoleId: string | undefined | null, allowedRoles?: readonly string[]) => {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  if (!userRoleId) return false;

  return allowedRoles.some((allowedRole) => allowedRole === userRoleId || (allowedRole === 'ADMIN' && isAdminLikeRole(userRoleId)));
};
